import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams,useNavigate } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';

import { useLocation } from 'react-router-dom';
import { UrlPath } from "../../../../config/routeConfig";
import { getUniverseMembersAction } from "../../../actions/universeMembers";
import { getUniverseListAction } from "../../../actions/universeListAction";

import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../../shared/topBar/TopBar";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import './UniverseDetails.css';


export const UniverseDetails = () => {
    const location = useLocation();
    const params = useParams();
    const dispatch = useDispatch();
    const gridApi = useRef();
    const history = useNavigate();
    const UniverseID = params.UniverseId;
    const Gstate = useSelector(state => state);
    const memberDetails = Gstate.AnalyticsReporting.memberList.UniverseMemberDetails;
    const UniverseMembers = Gstate.AnalyticsReporting.memberList || {};
    const memberDetailsLoading = Gstate.AnalyticsReporting.memberDetailsLoading;
    const universeList = Gstate.AnalyticsReporting.universeList || [];
    const [selectedUniverse, setSelectedUniverse] = useState(UniverseMembers);
    const [universeID, setUniverseID]=useState(UniverseID);
    const [render,setRender]=useState(false);
    const isEditable =Gstate.authorizationData.isEditable;
    useEffect(() => {
        document.title = `Universe Details`;
     },[]);
    useEffect(() => {
        if(universeList.lenght===0)
        {
            dispatch(getUniverseListAction());
        }
        if(UniverseMembers.UniverseId!==parseInt(params.UniverseId))
        {
            dispatch(getUniverseMembersAction(universeID));
        }
    }, [render,params]);
    
    useEffect(()=>{
        setSelectedUniverse(UniverseMembers);
    }, [Gstate]);


    const defaultColDef = { sortable: true, filter: true, flex: 1, floatingFilter: true };

    const getDateFormatted = (params) => {
        const isoDate = params.value;
        const formattedDate = moment(isoDate).format('MM-DD-YYYY');
        return formattedDate;
    };
    const columnDefs = [
        { field: "MemberName", headerName: "Investment", sort: 'asc', width: 400, filter: 'agTextColumnFilter' },
        { field: "MemberEntityTypeName", headerName: "Entity" },
        { field: "ReturnStartDate", headerName: "Return Start Date", cellRenderer: getDateFormatted },
        { field: "ReturnEndDate", headerName: "Return End Date", cellRenderer: getDateFormatted }
    ];
    const Level = [{ BreadCrumb: "Universe >", Routes: `${UrlPath.UniverseList}` }, { BreadCrumb: `${selectedUniverse?.UniverseName}`, Routes: `${UrlPath.UniverseMembers}${UniverseID}` }]
    const universeListDDChanged=(e)=>{
        e.value && history(`${UrlPath.UniverseMembers}${e.value.UniverseId}`);
        setUniverseID(e.value.UniverseId);
        setRender(value=>value+1);
    }
    const EditNavigate = () => {
            history(`${UrlPath.UniverseEdit}${UniverseID}`);
    };
    const CancelButtonClick = () => {
        if (location?.state?.ActiveTab === "UniverseList" || location.state === null) {
            history(`${UrlPath.UniverseList}`);
        }
        else if (location.state.ActiveTab === "Universe") {
            const preUniverseId = parseInt(location.state.UniverseId);
            history(`${UrlPath.UniverseMembers}${preUniverseId}`);
        }
    };

    return <>
        <div id="universeMembers">
            <TopBar label={`Universe Details`} />
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid mainContentData">
                <div>
                    <div className="gap-2 d-flex align-items-center my-2">
                    <div className="me-auto">
                    <h2 class="fw-medium fs-6 m-0">{selectedUniverse?.UniverseName}</h2>
                    </div>
                    <div className="w-25 my-2">
                    <SBAComboBox data={universeList} value={selectedUniverse} textField={'UniverseName'} valueField={"UniverseId"} onChange={universeListDDChanged}/>
                    </div>        
                     <div>
                            <button type="button" className="p-sm-btn mx-1" onClick={EditNavigate} disabled={!isEditable}>Edit</button>

                        </div>
                        <div>
                            <button type="button" className="s-sm-btn mx-1" onClick={CancelButtonClick}>Cancel</button>

                        </div>
                    </div>
               <div className="row">
               <div className="col-md-4">
                    <label className="label d-block">Description:</label>
                            <div className="value-spacing">{selectedUniverse?.UniverseDescription}</div>
                </div>
                <div className="col-md-4">
                    <label className="label d-block">Created On:</label>
                            <div className="value-spacing">{moment(selectedUniverse?.CreatedDate).format('MM-DD-yyyy')}</div>
                </div>
                <div className="col-md-4">
                    <label className="label d-block">Created By:</label>
                            <div className="value-spacing">{selectedUniverse?.CreatedByUserName}</div>
                </div>
                </div>
                <div className="row">
                <div className="col-md-4">
                    <label className="label d-block">Max Return Range:</label>
                            <div className="value-spacing">{selectedUniverse?.MaxReturnRange}</div>
                </div>
                <div className="col-md-4">
                    <label className="label d-block">Common Return Range:</label>
                            <div className="value-spacing" >{selectedUniverse?.CommonReturnRange}</div>
                </div>
                
               </div>
               </div>
                <div className="ag-theme-alpine" style={{ width: '100%' }}>
                    {memberDetailsLoading ? <> <LoadingScreen /></> :
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={memberDetails}
                            defaultColDef={defaultColDef}
                            pagination={false}
                            paginationPageSize={5}
                            onGridReady={params => {
                                gridApi.current = params.api;
                            }}
                           
                        >
                        </AgGridReact>
                    }
                </div>
            </div>
        </div>
    </>
}